import { Route } from "../models/flightSearch";

export function CalculateLuggageWeight(route:Route){
    if(route.Segments.some(x => x.Carrier.Code == 'TK') || route.Segments.some(x => x.Carrier.Code == 'AJ')){
      return '0 kg';
      var directFlightOrNot:number=route.Stopovers;
      if(directFlightOrNot>=1){
        var bgg = '25';
        for(var i=0;i<route.Segments.length;i++){
          if(route.Segments[i].Legs[0].Destination.Code == 'SAW'){
            // bgg = '20';
            bgg = '23';
          }
          if(route.Segments[i].Legs[0].Destination.Code == 'IST'){
            bgg = '30';
          }
          if(route.Segments[i].Legs[0].Destination.Code == 'ESB'){
            // bgg = '20';
            bgg = '23';
          }
        }
        return bgg;
      }
      else{
        var bagg = '25';       
        if(route.OriginAirport.Code == 'IST' || route.DestinationAirport.Code == 'IST'){
          bagg = '30'; 
        }
        return bagg;
      }
    }
    else{
      return '0 Kg';
    }
  }


  export function CaseForAirportsObsolete(code){
   var bagg = '0';
    switch(code){
      case 'ASR':
        bagg = '30';
        break;
      case 'ADB':
        bagg = '30';
        break;
      case 'KYA':
        bagg = '30';
        break;
      case 'ESB':
        bagg = '30';
        break;
      case 'IST':
        bagg = '30';
        break;
      case 'SAW':
        bagg = '25';
        break;
      case 'DLM':
        bagg = '25';
        break;
      case 'BJV':
        bagg = '25';
        break;
      case 'AYT':
        bagg = '25';
        break;
    }
  }